import React, { useContext } from 'react';
import { I18N, I18NContext } from 'commons';


const MobileAppSection = () => {
  const i18n = useContext(I18NContext);
  return (
    <div className="col-md-12 infor-box justify-content-center">
      <div className="m-3 text-center">
        <div className="label form-text">
          <I18N>new.registration.signup.create.account.receive.mobile.app</I18N>
        </div>
        <a
          className="image-app-store m-1"
          href="https://play.google.com/store/apps/details?id=com.everbridge.mobile.iv.recipient&feature=more_from_developer#?t=W251bGwsMSwxLDEwMiwiY29tLmV2ZXJicmlkZ2UubW9iaWxlLml2LnJlY2lwaWVudCJd"
          target="_blank"
          rel="noreferrer"
          aria-label={i18n['ssp.myprofile.banner.googleplay']}
        >
          <img
            src="/public/images/google-play-badge.svg"
            alt={i18n['ssp.myprofile.banner.googleplay']}
          />
        </a>
        <a
          className="image-app-store m-1"
          href="https://itunes.apple.com/us/app/everbridge-mobile-member/id565859420?mt=8#"
          target="_blank"
          rel="noreferrer"
          aria-label={i18n['ssp.myprofile.banner.appstore']}
        >
          <img
            src="/public/images/app-store-badge.svg"
            alt={i18n['ssp.myprofile.banner.appstore']}
          />
        </a>
      </div>
    </div>
  );
};

export default MobileAppSection;
